export default "__VITE_ASSET__COcDtwUx__"